import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminInquiries.cannedResponses;

export const cannedResponsesSelector = (state: RootState) => getState(state).data;

export const cannedResponsesIsLoadingSelector = (state: RootState) => getState(state).isLoading;

export const cannedResponsesErrorSelector = (state: RootState) => getState(state).error;

export const cannedResponseCategoriesSelector = (state: RootState) => getState(state).categories;

export const cannedResponseCategoriesIsLoadingSelector = (state: RootState) =>
  getState(state).categoriesIsLoading;

export const cannedResponseCategoriesErrorSelector = (state: RootState) =>
  getState(state).categoriesError;

export const cannedResponseSelectedCategorySelector = (state: RootState) =>
  getState(state).selectedCategory;

export const cannedResponsesIsDeletingSelector = (state: RootState) => getState(state).isDeleting;
